import {
  EnvironmentTypes,
  SiteConfig,
  footerApp,
  headerApp,
  shellApp,
} from "@openedx/frontend-base";
import { learnerDashboardApp } from "@edx/frontend-app-learner-dashboard";
import { subscriptionLearnerDashboardApp } from "@edx/frontend-app-subscription-learner-dashboard";
import { subscriptionManageApp } from "@edx/frontend-app-subscription-manage";
import { subscriptionCheckoutApp } from "@edx/frontend-app-subscription-checkout";
import { alacarteCheckoutApp } from "@edx/frontend-app-alacarte-checkout";
import { subscriptionSearchApp } from "@edx/frontend-app-subscription-search";
import { subscriptionEnrollApp } from "@edx/frontend-app-subscription-enroll";
import { notificationsApp } from '@edx/frontend-app-notifications';

import "@openedx/frontend-base/shell/style";
import "@openedx/brand-openedx/dist/core.min.css";
import "@openedx/brand-openedx/dist/light.min.css";

import edxPlusLogo from "./src/assets/edx_plus_logo.png";

const siteConfig: SiteConfig = {
  siteId: "learner-home-stage",
  siteName: "Learner Home Stage",
  baseUrl: "https://learner-home.stage.edx.org",
  lmsBaseUrl: "https://courses.stage.edx.org",
  loginUrl: "https://courses.stage.edx.org/login",
  logoutUrl: "https://courses.stage.edx.org/logout",

  headerLogoImageUrl: edxPlusLogo,

  environment: EnvironmentTypes.TEST,
  segmentKey: "TtPH7YIzUjUTrRSTWPodc5mEydwtCgU9",
  apps: [
    shellApp,
    headerApp,
    footerApp,
    learnerDashboardApp,
    subscriptionLearnerDashboardApp,
    subscriptionManageApp,
    subscriptionSearchApp,
    subscriptionCheckoutApp,
    alacarteCheckoutApp,
    subscriptionEnrollApp,
    notificationsApp,
  ],
  commonAppConfig: {
    STRIPE_PUBLIC_KEY:
      "pk_test_51ThYprEUxB2SCTmQzFjGc319F8Ubf3B5jXThzZD7zhibpvmvfXEVzvO1LMKkHWxQsMBSP6hkTmGO00FBZRNLuSml00X4NmQVft",
    ALACARTE_CHECKOUT_SEGMENT_WRITE_KEY: 'SdbaYu6BboYSPABPQiY2W0drKGxB4PDB',
    OVERWRITE_IS_SUBSCRIPTION: false,
    VIAX_API_URL: "https://api.twou.dev.viax.io/graphql",
    ALGOLIA_APP_ID: "testing2MLYZ9WWU0",
    ALGOLIA_SEARCH_API_KEY: "63b85c1e6330cd66675d74945fa3bc0e",
    ALGOLIA_PRODUCT_INDEX_NAME: "product",
    ENABLE_SUBSCRIPTION_SITE: true,
    ENABLE_ANNUAL_BILLING: false,
    COURSES_BASE_URL: "https://courses.stage.edx.org",
    TOS_URL: "https://odyssey-671.stage.edx.org/edx-terms-service",
    REFUND_POLICY_URL:
      "https://odyssey-671.stage.edx.org/edx-terms-service#refund-policy",
    PROGRAM_RECORDS_URL: "https://records.stage.edx.org/",
    DISABLE_COMPLIANCE_CHECK: false,
    SKIP_SUBSCRIPTION_COURSE_RUNS: false,
    PAYPAL_CLIENT_ID: "BAAyOtD02hqpaSJ9jhv4SlK766emSM_ZgRi68T8q_w6Jffdu3Jvf0jMX47bGildzq0_lI-b8WT8aGJqedU"
  },
  externalRoutes: [
    {
      role: "org.openedx.frontend.role.profile",
      url: "https://profile.stage.edx.org",
    },
    {
      role: "org.openedx.frontend.role.account",
      url: "https://account.stage.edx.org",
    },
    {
      role: "org.openedx.frontend.role.logout",
      url: "https://courses.stage.edx.org/logout",
    },
    {
      role: "org.openedx.frontend.role.learning",
      url: "https://learning.stage.edx.org",
    },
    {
      role: "org.openedx.frontend.role.subscription.search",
      url: "https://learner-home.stage.edx.org/subscription-search",
    },
  ],

  accessTokenCookieName: "stage-edx-jwt-cookie-header-payload",
};

export default siteConfig;
